import React from 'react';
import { Link } from 'react-router-dom';

import generatePath from '~settings/routing';

export default function CityItem({ cityData = [], firstLetter }) {
  return (
    <div className="city-item-wrapper">
      <p className="first-letter">{firstLetter}</p>
      <div className="city-item">
        {cityData.map((city, index) => (
          <Link
            className="city-name"
            key={index}
            to={generatePath(
              'strategy.cityHomepage',
              { name: city.node.originalName },
              { slug: city.node.slug, cityId: city.node.id },
            )}
          >
            {city.node.originalName}
          </Link>
        ))}
      </div>
    </div>
  );
}
